module.exports = __webpack_public_path__ + "static/img/logo.d15fa1e.png";


//////////////////
// WEBPACK FOOTER
// ./static/logo.png
// module id = 262
// module chunks = 1